// i18next configuration.
// Bundled English locale — no async loading needed at MVP.
// See ADR-030 for internationalization decision.

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import commonEn from './locales/en/common.json'
import layoutEn from './locales/en/layout.json'
import frameworkConfigEn from './locales/en/frameworkConfig.json'
import settingsEn from './locales/en/settings.json'
import platformEn from './locales/en/platform.json'

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  ns: ['common', 'layout', 'frameworkConfig', 'settings', 'platform'],
  defaultNS: 'common',
  resources: {
    en: {
      common: commonEn,
      layout: layoutEn,
      frameworkConfig: frameworkConfigEn,
      settings: settingsEn,
      platform: platformEn,
    },
  },
  interpolation: {
    escapeValue: false, // React handles escaping
  },
})

export default i18n
